<template>
    <div>
        <md-dialog :md-active.sync="mostrarModalServico" class="md-layout-item zindex" style="width: 550px; left: calc(50% - 225px); ">
            <div class="padding-20 modal-servico">

                <h2 class="robold">Incluir Disciplinas</h2>

                <form novalidate class="md-layout square-layout" @submit.prevent="validateUser">

                    <div class="md-layout-item md-size-100 md-small-size-100">
                        <md-field class="md-has-value">
                            <label for="gender">Serviços</label>
                            <md-select name="ServicoSelect" id="ServicoSelect" v-model="formModal.codigoTipoServico" md-dense :disabled="sending">
                                <md-option value="M">Sevico Teste</md-option>
                                <md-option value="F">Serrvocoo mionho</md-option>
                            </md-select>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-100 md-gutter">


                        <div class="md-layout-item md-size-40 md-small-size-100">
                            <md-field>
                                <label for="age">Valor/Parcela</label>
                                <md-input type="number" id="age" name="age" v-model="formModal.valor" :disabled="sending" />
                            </md-field>
                        </div>

                        <div style="display:grid" class="blue-check md-layout-item md-size-100 ">
                            <md-radio style="margin-top: 5px;" class="md-primary" v-model="formModal.parcelamento" value="unica">Parcela Única</md-radio>
                            <md-radio style="margin-top: 0; margin-bottom:6px;" class="md-primary" v-model="formModal.parcelamento" value="varias">Várias Parcelas</md-radio>
                        </div>
                    </div>


                    <div class="md-layout md-gutter" v-if="formModal.parcelamento == 'varias'">


                        <div class="md-layout-item md-size-30 md-small-size-100">
                            <md-field>
                                <label for="gender">Quantidade</label>
                                <md-select name="ServicoSelect" id="ServicoSelect" v-model="formModal.parcelas" md-dense :disabled="sending">
                                    <md-option></md-option>
                                    <md-option value="M">M</md-option>
                                    <md-option value="F">F</md-option>
                                </md-select>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-size-30  md-small-size-100">
                            <md-field>
                                <label for="age">Primeira Parcela</label>
                                <md-input type="number" style=" width: 100%; " id="age" name="age" v-model="formModal.primeiraParcela" :disabled="sending" />
                            </md-field>
                        </div>

                    </div>


                    <div class="md-layout-item md-size-100">
                        <div class="md-layout-item md-size-50">
                            <md-field>
                                <label for="gender">Forma de Pagamento</label>
                                <md-select name="ServicoSelect" id="ServicoSelect" v-model="formModal.forma" md-dense :disabled="sending">
                                    <md-option value="Boleto">Boleto</md-option>
                                    <md-option value="Carne">Carnê</md-option>
                                </md-select>
                            </md-field>
                        </div>

                    </div>
                    <div class="md-layout-item md-size-100 textarea">
                        <label>Observação</label>
                        <textarea v-model="formModal.observacao" sstyle="height: 47px;" :disabled="sending"></textarea>
                    </div>

                </form>


                <md-dialog-actions class="divRight">
                    <md-button class="md-primary" @click="log()">Salvar</md-button>
                </md-dialog-actions>




            </div>
        </md-dialog>
        <div>
            <DropdownMenu titulo="Serviços" propExibicao="nome" propSelecao="id" :Data="ListaServ" :selected.sync="selectedServ"></DropdownMenu>
            <div style="display:inline-block;position:fixed;top:6.3em;margin-left:2em" class="blue-check">
                <md-radio style="margin-top: 0;" class="md-primary" v-model="status" value="Pago">Pago</md-radio>
                <md-radio style="margin-top: 0;" class="md-primary" v-model="status" value="Aberto">Aberto</md-radio>
            </div>

            <md-button style="text-transform:initial; height:40px; margin-top:0; float:right" class="md-text-and-icon s-h4 md-raised md-primary md-dense" @click="modalIncluirServico()">
                Incluir
                <md-icon style="font-weight:300;margin-left: 10px">playlist_add</md-icon>
               
            </md-button>
        </div>



        <Loading v-bind:show="showLoadingAtivos">
            <PageTitle title="Serviços - Ativos" />
            <Grid v-if="dadosAba && dadosAba.servico && $featureToggle && $featureToggle.INTEGRA_SERVICOS_ATIVOS"
                  v-bind:Data="dadosAba.servico"
                  v-bind:Header="headerAtivos"
                  Name="ServicosAtivos"
                  Title="Ativos"
                  OrderBy="datavencimento"
                  v-bind:HeaderDetalhes="headerDetalhe"
                  v-bind:DetalhesCombo1="dadosAba.periodo"
                  v-bind:DetalhesCombo2="dadosAba.situacao"
                  v-bind:DetalhesCombo3="dadosAba.descricao"
                  @carregaAba="ativos()"/>
        </Loading>
    </div>
</template>
<script>
    import Grid from '@/components/Grid';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import Servico from '@/services/ServicoService.js';

    export default {
        name: 'Servico',
        components: {
            Grid,
            Loading,
            PageTitle,
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {

            this.servicoService = new Servico(this);

                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.ServicoAtivo) {
                        this.dadosAba = a.Servicos;
                    }
                    else
                        this.dadosAba = this.ativos();
                }
                else
                    this.$router.push('home');
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.ServicoAtivo = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                formModal: {
                    parcelamento: null,
                    codigoTipoServico: null,
                    valor: null,
                    primeiraParcela:null,
                    codigoCarteira: null,
                    observacao:''
                },
                sending: false,
                status: "Pago",
                mostrarModalServico: false,
                ListaServ: [{ id: 1, nome: "var1" }, { id: 2, nome: "cam2" }],
                selectedServ: null,
                servicosCancelados: null,
                aluno: null,
                activeTab: "ativos",
                showLoadingAtivos: false,
                showLoadingCancelados: false,
                headerAtivos: [
                    { Titulo: "Descrição", Field: "descricaoCompleta", Width: "200px", Tipo: "texto" },
                    { Titulo: "Valor", Field: "valor_titulo", Width: "80px", Tipo: "moeda" },
                    { Titulo: "Valor Corrigido (R$)", Field: "valor_atualizado", Width: "80px", Tipo: "moeda" },
                    { Titulo: "Vencimento", Field: "data_vencimento", Width: "80px", Tipo: "date" },
                    { Titulo: "Situação", Field: "situacao", Width: "100px", Tipo: "texto" },
                    { Titulo: "Boleto", Valor: "numero_documento", Width: "80px", Tipo: "button", Condicao: "Em Aberto", Campo: "situacao", Metodo: "GerarBoleto", Servico: "Financeiro", Acao: "pdf" },
                    { Titulo: "Remover", Field: "remover", Width: "20px", Tipo: "remove-button" }
                ],

                headerDetalhe: [
                    { Titulo: "Observação", Field: "observacao", Tipo: "texto" },
                    { Titulo: "Tipo Baixa", Field: "tipo_Baixa", Tipo: "texto" },
                    { Titulo: "Tipo Pagamento", Field: "tipo_Pagamento", Tipo: "texto" },
                    { Titulo: "Valor Desconto", Field: "valor_desconto", Tipo: "moeda" },
                    { Titulo: "Transação", Field: "numero_transacao", Tipo: "numero" },
                    { Titulo: "Data Pagamento", Field: "data_pagamento", Tipo: "date" }
                ],

                dadosAba: null
            }
        },
        methods: {
            log() {
                this.mostrarModalServico = false;
                console.log(this.formModal);
                let modalButtons = [
                    { text: "Cancelar Geração", action: () => this.setLog("Cancelado"), class: "md-primary" },
                    { text: "Confirmar Geração", action: () => this.setLog("Confirmado"), class: "md-primary" }
                ]

                this.$modal.custom("Você confirma a geração do serviço?", modalButtons)
            },
            setLog(a) {
                alert(a)
            },
            modalIncluirServico() {
                this.mostrarModalServico = true;
            },
            ativos() {
                if (this.$featureToggle.INTEGRA_SERVICOS_ATIVOS) {
                    this.showLoadingAtivos = true;
                    this.servicoService.ListarServicosAlunoAtivos({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        Pagina: 1,
                        ItensPagina: 100,
                        Situacao: null,
                        Origem: null,
                        Fim: null
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoadingAtivos = false;
                        });
                }
                else {
                    this.$modal.alert(this.$msgFeatureToggle);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .md-tab {
        padding: 0;
        margin: 0 !important;
    }

    .divLeft200 {
        width: 200px;
        float: left;
        position: relative;
        display: inline;
        padding: 5px 0 0 5px
    }

    .padding-20 {
        padding: 20px 40px 10px 40px;
    }

    .square-layout.square-layout.square-layout .md-field.md-theme-default:after {
        background-color: initial;
    }

    .square-layout.square-layout.square-layout .md-menu.md-select,
    .square-layout.square-layout.square-layout .md-input {
        border: 1px solid #B1C2D5;
       
    }

    .square-layout label {
        pointer-events: auto;
        top: 0;
        opacity: 1;
        font-size: 12px;
    }

    .square-layout .textarea {
        display: grid
    }

        .square-layout .textarea textarea {
            border-color: #B1C2D5;
        }

            .square-layout .textarea textarea:focus {
                outline: blue auto 4px;
            }

    .modal-servico.modal-servico.modal-servico h2 {
        font-size: 18px
    }

    .modal-servico.modal-servico.modal-servico label,
    .modal-servico.modal-servico.modal-servico .md-radio-label {
        font-size: 12px;
        font-weight: bold;
        color: black;
        white-space: nowrap;
    }


    .modal-servico.modal-servico.modal-servico .md-field {
        margin-bottom: 8px !important
    }

    input[type="text"] {
        font-size: 55px;
    }
</style>
